
import { v4 as uuidv4 } from 'uuid';

export interface Event {
  id: string;
  name: string;
  date: string;
  time: string;
  location: string;
  attendees: number;
  description?: string;
  image?: string;
}

export const generateEvents = (): Event[] => {
  const eventNames = [
    'Annual Business Summit', 
    'Networking Mixer', 
    'Industry Leadership Panel', 
    'Market Expansion Workshop', 
    'Investor Pitch Day', 
    'Entrepreneurship Bootcamp', 
    'Trade Fair', 
    'Digital Marketing Masterclass'
  ];
  
  const locations = [
    'Nairobi, Kenya', 
    'Lagos, Nigeria', 
    'Cape Town, South Africa', 
    'Accra, Ghana', 
    'Virtual'
  ];
  
  const descriptions = [
    'Join us for a day of networking, learning, and inspiration at our annual business conference focused on African entrepreneurship.',
    'A three-day workshop series teaching entrepreneurs how to set up and grow their online businesses.',
    'Networking event for women entrepreneurs to share experiences and build connections.',
    'Expert-led sessions on leveraging digital marketing to grow African businesses.',
    'Practical workshop on optimizing supply chains for small and medium enterprises.',
    'Connect with potential investors and showcase your business ideas in this intensive pitch session.',
    'Learn from industry leaders about emerging market trends and growth opportunities.',
    'Hands-on training for entrepreneurs looking to expand their business across borders.'
  ];
  
  const today = new Date();
  
  return Array.from({ length: 6 }, (_, i) => {
    const eventDate = new Date(today);
    eventDate.setDate(today.getDate() + Math.floor(Math.random() * 30) + 5);
    
    return {
      id: uuidv4(),
      name: eventNames[i % eventNames.length],
      date: eventDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }),
      time: `${Math.floor(Math.random() * 12) + 1}:00 ${Math.random() > 0.5 ? 'AM' : 'PM'}`,
      location: locations[Math.floor(Math.random() * locations.length)],
      attendees: Math.floor(Math.random() * 100) + 20,
      description: descriptions[i % descriptions.length],
      image: "/placeholder.svg"
    };
  });
};

// Create a singleton pattern to ensure the same events are used everywhere
let events: Event[] | null = null;

export const getEvents = (): Event[] => {
  if (!events) {
    events = generateEvents();
  }
  return events;
};
